import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ID } from '../../@types/api';
import { FirewallSecurityGroupMetadataBase } from '../../@types/firewall-security-group';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useUpdateSecurityGroupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body: ID & FirewallSecurityGroupMetadataBase) =>
            Endpoints.v1.Firewalls.SecurityGroups.updateSecurityGroup(body),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-groups.infinite'],
            });
            notifications.show({
                title: t('securityGroup.updatedTitle'),
                message: t('securityGroup.updatedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('securityGroup.updateFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
